import { useMemo } from "react";
import { useSelector } from "react-redux";
import PropTypes from "prop-types";
import { getPersonalizedDateFormat } from "../../store/selectors/selector.configOptions.jsx";
import { formatLocalDate } from "../../utils/date.jsx";

export const FormatLocalDate = ({ value, long }) => {
  const format = useSelector(getPersonalizedDateFormat);

  const formattedValue = useMemo(() => {
    return formatLocalDate(value, format, long);
  }, [value, format, long]);

  return formattedValue;
};

FormatLocalDate.propTypes = {
  value: PropTypes.number.isRequired,
  long: PropTypes.bool,
};

FormatLocalDate.defaultProps = {
  long: true,
};
